import { Component } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { GxInputDirective } from '../../../../directives/gxinput.directive';
import { UserFeedbackService } from '../../../global/feedback-popup/user-feedback.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { LetDirective } from '@ngrx/component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-gx-wrapped-feedback',
  standalone: true,
  imports: [
    MatFormField,
    MatButton,
    ReactiveFormsModule,
    MatInput,
    GxInputDirective,
    MatLabel,
    TranslateModule,
    MatTooltip,
    NgClass,
    LetDirective,
    MatProgressSpinner,
  ],
  templateUrl: './gx-wrapped-feedback.component.html',
  styleUrls: ['../../../global/feedback-popup/_radioStyles.scss',
              './gx-wrapped-feedback.component.scss'],
  providers: [UserFeedbackService]
})
export class GxWrappedFeedbackComponent {

  constructor(public userFeedback: UserFeedbackService) {
  }

}
